module.exports = __webpack_public_path__ + "static/media/img-physical-qr-01.3f5a593e.svg";